module.exports = __webpack_public_path__ + "static/media/googleLogo.70be07f0.svg";